import { ErrorOutline } from '@mui/icons-material'
import { Alert, Button, Stack, Typography } from '@mui/material'
import React from 'react'

type FailedStepProps = {
  errorMessage: string | null | undefined
  onClose: () => void
}

const FailedStep: React.FC<FailedStepProps> = ({ errorMessage, onClose }) => {
  return (
    <Stack spacing={4} alignItems="center">
      <ErrorOutline sx={{ fontSize: 80, color: 'error.main' }} />
      <Typography variant="h4">Import Failed</Typography>
      {errorMessage && (
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          {errorMessage}
        </Alert>
      )}
      <Button variant="contained" onClick={onClose}>
        Close
      </Button>
    </Stack>
  )
}

export default FailedStep
